// src/modulos/Dashboard/dashboards/AdminDashboard.js
import React from 'react';
import { useNavigate } from 'react-router-dom';

const AdminDashboard = ({ user }) => {
    const navigate = useNavigate();

    return (
        <div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px', marginTop: '30px' }}>
                {/* User Management Card */}
                <div style={{ padding: '20px', border: '1px solid #ccc', borderRadius: '8px', backgroundColor: '#fff' }}>
                    <h3>👥 Gestão de Usuários</h3>
                    <p>Gerencie usuários, permissões e acessos ao sistema.</p>
                    <button onClick={() => navigate('/usuarios')} style={{ marginTop: '10px', padding: '8px 16px', cursor: 'pointer' }}>
                        Gerenciar Usuários
                    </button>
                </div>

                {/* Permissions Card */}
                <div style={{ padding: '20px', border: '1px solid #ccc', borderRadius: '8px', backgroundColor: '#fff' }}>
                    <h3>🔐 Controle de Permissões</h3>
                    <p>Configure permissões de acesso por cargo/role.</p>
                    <button onClick={() => navigate('/permissoes')} style={{ marginTop: '10px', padding: '8px 16px', cursor: 'pointer' }}>
                        Configurar Permissões
                    </button>
                </div>

                {/* System Overview Card */}
                <div style={{ padding: '20px', border: '1px solid #ccc', borderRadius: '8px', backgroundColor: '#fff' }}>
                    <h3>📈 Visão Geral do Sistema</h3>
                    <ul style={{ marginTop: '10px', paddingLeft: '20px' }}>
                        <li>Total de usuários ativos: 25</li>
                        <li>Módulos disponíveis: 8</li>
                        <li>Último backup: 10/12/2024</li>
                    </ul>
                </div>

                {/* Parameters Card */}
                <div style={{ padding: '20px', border: '1px solid #ccc', borderRadius: '8px', backgroundColor: '#fff' }}>
                    <h3>⚙️ Parâmetros do Sistema</h3>
                    <p>Configure parâmetros gerais do sistema.</p>
                    <button onClick={() => navigate('/parametros')} style={{ marginTop: '10px', padding: '8px 16px', cursor: 'pointer' }}>
                        Configurar Parâmetros
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AdminDashboard;